import React from 'react';
import { connect } from 'react-redux';
import { v4 } from 'uuid';

import Retention from '../../components/retention/Retention';
import {
  getExecuteIdsFromJobIds,
  getRetentionExecuteId,
  isRetentionExecuting,
} from '../../reducers/analyticsApp';
import {
  executeRetention,
  executeRetentionCsv,
  setRetentionExecuteId,
} from '../../actions/retention/retention';
import { cancelRequest } from '../../api/execute';
import CsvDownloadButton from '../navigation/csv/CsvDownloadButton';
import CsvRequests from '../navigation/csv/CsvRequests';

const mapStateToProps = (state) => {
  const executeIds = getExecuteIdsFromJobIds(state);
  const executeId = getRetentionExecuteId(state);

  return {
    executing: isRetentionExecuting(state),
    extraActions: [
      {
        renderElement: (closeMenu) => (
          <CsvDownloadButton
            title="Download CSV"
            clickHandler={executeRetentionCsv}
            closeMenu={closeMenu}
          />
        ),
      },
      { renderElement: (closeMenu) => <CsvRequests closeMenu={closeMenu} /> },
    ],
    cancelButtonDisabled: !executeIds.includes(executeId),
    executeId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onExecute: () => {
    const executeId = v4();
    dispatch(setRetentionExecuteId(executeId));
    return dispatch(executeRetention(executeId));
  },
  onRequestCancel: (executeId) => dispatch(cancelRequest(executeId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onRequestCancel: () => dispatchProps.onRequestCancel(stateProps.executeId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Retention);
